import axios from "axios";
import { Amplify } from 'aws-amplify';
import {
    API_ORG_INFO,
    GORGIAS_LAMBA_API,
    TRIGGER_DATA_IMPORT,
    DATA_IMPORT_STATUS,
    AGGREGATE_DATA,
    EVENTS,
}
from './constants/Endpoints'
import { toggleSnackbar,
  SAVE_ORG_DETAILS,
  ORG_DETAILS_LOADING,
  SAVE_DOMAIN,
  AGENT_DETAILS_LOADING,
  SAVE_AGENT_DETAILS,
  TICKET_DETAILS_LOADING,
  SAVE_TICKET_DETAILS,
  SAVE_TICKET_ID,
  SAVE_EMAIL,
  SAVE_ORG_ID,
  saveDomain,
  SAVE_PRISM_TOKEN,
  DATA_IMPORT_LOADING,
  SAVE_DATA_IMPORT_DETAILS,
  GPT_SANDBOX_LOADING,
  ADD_TO_GPT_SANDBOX,
  CUSTOMER_SUMMARY_LOADING,
  SAVE_CUSTOMER_SUMMARY,
  CASE_SUMMARY_LOADING,
  SAVE_CASE_SUMMARY,
  PAST_TICKETS_LOADING,
  SAVE_PAST_TICKETS,  
} from "../src/redux/actions/authActions";
import {clearGPTAnswersForResearch, clearResearch, startLoading, stopLoading, handleGPTResponse} from "../src/redux/actions/ticketActions"
import {gptOneTouchAnswersForTicketResearch,} from './apis/ticketResearch'
import { combinedActionMap } from "./constants/CombinedActionMap";
import {convertHTMLtoMarkdown, convertMarkdownToHtml} from "./constants/utils";


const waitMessages = [
  "Hang tight — we’re still working on your request. Just a moment!",
  "Our system is taking a bit longer to connect. We’re retrying automatically.",
  "Connecting... this might take a few seconds. Please don’t refresh.",
  "Still trying to connect. If this takes too long, you can try again later."
];

function getWaitMessage(retry) {
  switch (retry) {
    case 1:
      return waitMessages[1];
    case 2:
      return waitMessages[0];
    case 0:
    default:
      const index = 2 + Math.floor(Math.random() * 2);
      return waitMessages[index];
  }
}

const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));


export const retryWrapper = async ({
  url,
  httpMethod = 'get',
  params = {},
  payload = {},
  headers = {
    'x-api-key': process.env.REACT_APP_API_KEY
  },
  maxRetries = 3,
  dispatch = null
}) => {
  if (maxRetries <= 0) {
    console.error('Max retries reached.');
    return;
  }
  console.log("maxRetries",maxRetries)
  try {
    let response;

    if (httpMethod.toLowerCase() === 'get') {
      response = await axios.get(url, { params, headers });
    } else if (httpMethod.toLowerCase() === 'post') {
      response = await axios.post(url, payload, {
        headers,
        params
      });
    } else {
      throw new Error(`Unsupported HTTP method: ${httpMethod}`);
    }
    return response;
  } catch (error) {
    const isTimeout = error.response?.status === 504;
    const isNetworkError = error.code === 'ERR_NETWORK';
    if (isTimeout || isNetworkError) {
      console.warn(`Timeout occurred. Retrying... (${maxRetries - 1} retries left)`);

      const message = getWaitMessage(maxRetries);
      if(dispatch){
        dispatch(toggleSnackbar({
          message,
          status: true,
          severity: "info"
        }));  
      }
      await sleep(30000);
      return retryWrapper({url, httpMethod, params, payload, headers, maxRetries : maxRetries - 1, dispatch});
    }

    console.error('Request failed:', error.message);
    throw error;
  }
};

function findLinksInText(inputString) {
    const linkMap = {};
    let count = 1;
    inputString = inputString.replace(/<a\s+href=["']([^"']+)["'][^>]*>(.*?)<\/a>/gi, (_, href, text) => {
        const key = `[link${count}]`;
        linkMap[key] = `<a href="${href}" rel="noopener noreferrer" target="_blank">${text}</a>`;
        count++;
        return key;
    });
    inputString = inputString.replace(/\[([^\]]+)\]\((https:\/\/[^\s)]+)\)/gi, (_, text, href) => {
      const key = `[link${count}]`;
      linkMap[key] = `<a href="${href}" rel="noopener noreferrer" target="_blank">${text}</a>`;
      count++;
      return key;
  });
    inputString = inputString.replace(/(?<!["'=])\bhttps:\/\/[^\s<>()]+/gi, (match) => {
        const key = `[link${count}]`;
        linkMap[key] = `<a href="${match}" rel="noopener noreferrer" target="_blank">${match}</a>`;
        count++;
        return key;
    });

    return [inputString, linkMap];
}

export const getOrgData = (org) => {
    return async (dispatch,getState) => {
        dispatch({
          type :ORG_DETAILS_LOADING,
          payload : true
        })
        try {
          const response = await retryWrapper({url : API_ORG_INFO , params : { subdomain: org }, dispatch})
          const content = response?.data?.org_data ?? {};
          if (response.status === 200 && Object.keys(content).length > 0 ){
            content["_id"] = content?.prismOrgId ?? content?._id
            Amplify.configure({
              Auth: {
                Cognito: {
                  userPoolId: content["cognito"]["userpool_id"],
                  userPoolClientId: content["cognito"]["client_id"],
                  loginWith: {
                    username: true
                  }
                }
              }
            });
            dispatch({
              type: SAVE_ORG_ID,
              payload: content?.prismOrgId ?? content?._id
              })
            dispatch({
              type: SAVE_ORG_DETAILS,
              payload: content ?? {}
            })
            dispatch({
              type: SAVE_DOMAIN,
              payload: org
            })
          }
          if (response.status === 200 && Object.keys(response?.data).length > 0 && content?.dataImport){
            dispatch({
              type: SAVE_PRISM_TOKEN,
              payload: response?.data?.org_data?.dataImport?.accessToken
              })
          }
          if (! Object.keys(content).length > 0){
            dispatch(toggleSnackbar({
              message: `We couldn't find any organization with the provided name. Could you please enter the correct organization name? `,
              status: true,
              severity: "error",
            }))

          }
          
        } catch (ex) {
          console.error("error",ex);
          dispatch(toggleSnackbar({
            message: "Failed to get Org status",
            status: true,
            severity: "error",
          }))
        }
        dispatch({
          type :ORG_DETAILS_LOADING,
          payload : false
        })
      }
  };


export const getAgentDetails = (userEmail,ticketingSystem,orgId,prismToken)=>{
  return async (dispatch) =>{
    dispatch({
      type : AGENT_DETAILS_LOADING,
      payload : true
    })
    try {
      const response = await retryWrapper({url : GORGIAS_LAMBA_API , httpMethod : "post", params : { orgid: orgId }, payload : {
                                                                              operation: "verifyuser",
                                                                              user_email: userEmail,
                                                                              ticketingSystem: ticketingSystem,
                                                                              orgId : orgId,
                                                                            },headers : {
                                                                                          "Authorization": `Bearer ${prismToken}`
                                                                                                }, dispatch  })
      if (response?.status === 200){
        if (response?.data?.verified){
          dispatch({
            type: SAVE_AGENT_DETAILS,
            payload: response?.data
          })
          dispatch({
            type: SAVE_EMAIL,
            payload: userEmail
          })
        }else{
          dispatch(toggleSnackbar({
            message: `${userEmail} is not a verified User`,
            status: true,
            severity: "error",
          }))

        }
        
    }else{
      dispatch(toggleSnackbar({
        message: "Failed to get agent status",
        status: true,
        severity: "error",
      }))
    }              
    } catch (ex) {
      console.error("error",ex);
      dispatch(toggleSnackbar({
        message: "Failed to get agent status",
        status: true,
        severity: "error",
      }))

  }
  dispatch({
    type :AGENT_DETAILS_LOADING,
    payload : false
  })
}
};


export const getTicketDetails = (ticketId,subdomain,ticketingSystem,orgId,prismToken)=>{
  return async(dispatch) =>{
    dispatch({
      type : TICKET_DETAILS_LOADING,
      payload : true
    })
    try {
      const response = await retryWrapper({url : GORGIAS_LAMBA_API,httpMethod : "post",params : {orgid : orgId},payload : {
                          subdomain: subdomain,
                          ticketId: ticketId,
                          operation : "getTicketDetails",
                          orgId : orgId,
                          ticketingSystem: ticketingSystem}, headers : {
                                              "Authorization": `Bearer ${prismToken}`
                            } ,dispatch } )
          if (response?.status === 200){
              if (!response?.data || (typeof response.data === 'object' && Object.keys(response.data).length === 0)) {
                dispatch(toggleSnackbar({
                  message: `Unable To Fetch Details For Ticket ${ticketId}. Please Try With The Different Ticket ID`,
                  status: true,
                  severity: "error",
                }))
              }
        
          dispatch({
            type: SAVE_TICKET_DETAILS,
            payload: response?.data
          })
          dispatch({
            type: SAVE_TICKET_ID,
            payload: ticketId
          })
          dispatch(clearResearch())
          dispatch(clearGPTAnswersForResearch())
      }else{
        dispatch(toggleSnackbar({
          message: response?.data,
          status: true,
          severity: "error",
        }))
      }              
    } catch (ex) {
      console.error("error",ex);
      dispatch(toggleSnackbar({
        message: "Unable to retrieve ticket details. Could you please try with a different ticket ID?",
        status: true,
        severity: "error",
      }))
  }
  dispatch({
    type :TICKET_DETAILS_LOADING,
    payload : false
  })

  }
};

export const initateDataImport = (payload,orgId,prismToken,subDomain)=>{
  return async(dispatch) =>{
    let dataImportTriggered = true;
    dispatch({
      type : DATA_IMPORT_LOADING,
      payload : true
    });
    try {
      const response = await axios.post(`${TRIGGER_DATA_IMPORT}?orgid=${orgId}`,
                      payload,
                      {
                        headers: {
                        "Authorization": `Bearer ${prismToken}`
                      }});
      if (response?.status === 200){
        dispatch(toggleSnackbar({
          message: `Data Import successfully triggered `,
          status: true,
          severity: "success",
        }))
        dispatch({
          type : DATA_IMPORT_LOADING,
          payload : true
        });
      }else{
        console.error(`data import status failed with response status code ${response?.status} : ${response?.data}`)
        dataImportTriggered = false;
        dispatch(toggleSnackbar({
          message: "Data Import triggered failed",
          status: true,
          severity: "error",
        }))
      }              
    } catch (ex) {
      console.error("error",ex);
      dataImportTriggered = true;
      dispatch(toggleSnackbar({
        message: "Data Import triggered failed",
        status: true,
        severity: "error",
      }))
  }
  if (dataImportTriggered) {
    const intervalId = setInterval(async () => {
      const dataImport = await dispatch(getDataImportStatus(orgId, prismToken, subDomain, intervalId));
      if (dataImport?.status === 'completed') {
        clearInterval(intervalId);
        dispatch({
          type: DATA_IMPORT_LOADING,
          payload: false
        });
        dispatch(updateWidget(orgId,prismToken,subDomain,payload?.ticketingSystem))
        dispatch(toggleSnackbar({
          message: "Data Import Completed",
          status: true,
          severity: "success",
        }))
      }
    }, 10000); // Check every 10 seconds
  } else {
    dispatch({
      type: DATA_IMPORT_LOADING,
      payload: false
    });
  }
  }
};


export const getDataImportStatus = (orgId, prismToken, subDomain, intervalId) => {
  return async (dispatch, getState) => {
    try {
      const response = await axios.get(`${DATA_IMPORT_STATUS}`,{
        params: { orgId: `${orgId}` },
        headers: {
          "Authorization": `Bearer ${prismToken}`
        }
      });
      if (response?.status === 200) {
        const state = getState().auth;
        if (state.orgId !== orgId) {
          dispatch({
            type: SAVE_ORG_ID,
            payload: orgId
            })
        }
        if (state.prismToken !== prismToken) {
          dispatch({
            type: SAVE_PRISM_TOKEN,
            payload: prismToken
            })
        }

        if (state.subDomain !== subDomain) {
          dispatch(saveDomain(subDomain));
          dispatch(getOrgData(subDomain))
        }
        dispatch({
          type: SAVE_DATA_IMPORT_DETAILS,
          payload: response?.data
        });
        return response?.data;
      } else {
        clearInterval(intervalId);
        dispatch({
          type: DATA_IMPORT_LOADING,
          payload: false
        });
        dispatch(toggleSnackbar({
          message: "Data Import status request failed",
          status: true,
          severity: "error",
        }));
        return 'failed';
      }
    } catch (error) {
      console.error("get dataimport status lambda failed error", error);
      clearInterval(intervalId);
      dispatch({
        type: DATA_IMPORT_LOADING,
        payload: false
      });
      dispatch(toggleSnackbar({
        message: "Data Import status request failed",
        status: true,
        severity: "error",
      }));
      return 'failed';
    }
  };
};


export const updateWidget = (orgId,prismToken,subDomain,ticketingSystem) =>{
  return async(dispatch) =>{
    try{
      const response = await axios.post(`${GORGIAS_LAMBA_API}?orgid=${orgId}`, 
        {'prismToken' : prismToken,'orgId' : orgId,'subDomain' : subDomain,'operation' : 'updatewidget',ticketingSystem: ticketingSystem},
        {
          headers: {
          "Authorization": `Bearer ${prismToken}`
        }
      }
      );
      if (response.status === 201){
        dispatch(toggleSnackbar({
          message: "Updated the ticket side bar widget!",
          status: true,
          severity: "success",
        }));
      }else{
        dispatch(toggleSnackbar({
          message: "Failed to update the widget in the ticket side bar",
          status: true,
          severity: "error",
        }));
      }
    }
    catch(error){
      console.error("Failed to update the widget in the ticket sidebar  due to ",error)
      dispatch(toggleSnackbar({
        message: "Failed to update the widget in the ticket side bar",
        status: true,
        severity: "error",
      }));
    }
  }
}



export const generateGPTAnswer = (actionType, query,ticketDetails,userEmail,userRole,intentsity,prismToken,orgId,selectedText,beforeText,afterText)=>{
  return async (dispatch) =>{
    dispatch({
      type: GPT_SANDBOX_LOADING,
      payload: true
    })
    try{
      let promptText = selectedText!==''? selectedText : query;
      promptText = convertHTMLtoMarkdown(promptText);
      const  [queryText , anchorTagsobj] = findLinksInText(promptText);
      const question = queryText.replaceAll('<p>','\n').replaceAll('</p>','\n').replaceAll('<br>','\n')
      const requestBody = {
        prompt: actionType,
        text: question,
        ticketId: ticketDetails?.id,
        agent: userEmail,
        role: userRole,
        temperature: intentsity/10 *2
    };
    const response = await retryWrapper({url : AGGREGATE_DATA, httpMethod : "post", params : {orgid : orgId}, payload : requestBody, 
      headers :  {
                "Authorization": `Bearer ${prismToken}`
              },dispatch })
    if (response?.status === 200){
      const responseData = response?.data?.response;
      let content = `${beforeText}${responseData}${afterText}`;
      for (const [key, link] of Object.entries(anchorTagsobj)) {
        const regex = new RegExp(`\\${key}`, 'g');
        content = content.replace(regex, link);
      }
      content = content.replaceAll('\n','<br/>');
      dispatch({
        type: ADD_TO_GPT_SANDBOX,
        payload: {
            action: actionType, content: convertMarkdownToHtml(content)
        }
      })
      dispatch(updateEvent("gptTransform",`${actionType} : ${queryText}}`,ticketDetails?.id,ticketDetails?.subject || ticketDetails?.question || ticketDetails?.description,userEmail,orgId,prismToken));
    }else{
      dispatch(toggleSnackbar({
        message: `Request failed with ${response?.status}`,
        status: true,
        severity: "error",
      }));
    }
  }
  catch(error){
    console.error("error in generate GPT answer due to",error)
    dispatch(toggleSnackbar({
      message: `Failed to generate a response`,
      status: true,
      severity: "error",
    }));
  }
  dispatch({
    type: GPT_SANDBOX_LOADING,
    payload: false
  })
  }
} 
export const generateOneTouchAnswer = (actionType, subDomain, ticketingSystem, ticketDetails, userEmail, userId, buttonType, orgId, prismToken ,dispatch) => {
  return async (dispatch) => {
    startLoading(dispatch, GPT_SANDBOX_LOADING);
    const loadingActionType = `GPT_ANSWER_${buttonType.toUpperCase()}_LOADING`;
    startLoading(dispatch, loadingActionType);
    try {
      const operation = combinedActionMap?.[`${buttonType}`]?.['operation'];
      const event = combinedActionMap?.[`${buttonType}`]?.['event'];
      const response = await gptOneTouchAnswersForTicketResearch({operation,prismToken,subDomain,ticketingSystem,ticketDetails,orgId,userEmail,userId , dispatch})
      
      if (response?.status === 200) {
        let content = response?.data.replaceAll('\n', '<br/>');
        if (operation === "gptanswerfortickets" && content === "no transcript from similar tickets"){
          dispatch(toggleSnackbar({
            message: `No conversation between agent and customer to generate an answer from similar tickets`,
            status: true,
            severity: "info"
          }));
          content = "I'm sorry, I could not generate an answer";
        }
        dispatch({
          type: ADD_TO_GPT_SANDBOX,
          payload: {
            action: actionType,
            content: convertMarkdownToHtml(content)
          }
        });
        handleGPTResponse(dispatch, buttonType, content);

        dispatch(updateEvent(event, "", ticketDetails?.id, ticketDetails?.subject, userEmail, orgId, prismToken));

        }
      else {
        dispatch(toggleSnackbar({
          message: `One touch request failed`,
          status: true,
          severity: "error"
        }));
      }
    } catch (error) {
      console.error(`Error while generating one touch answer:`, error);
      dispatch(toggleSnackbar({
        message: `Failed to generate an answer for one touch`,
        status: true,
        severity: "error"
      }));
    }

    stopLoading(dispatch, loadingActionType);
    stopLoading(dispatch,GPT_SANDBOX_LOADING)
  };
};
  

export const insertTextToTicket = (comment,ticketingSystem,subDomain,userEmail,orgId,ticketDetails,prismToken) =>{
  return async (dispatch) =>{
   try{
    const requestBody = {
      ticketingSystem: ticketingSystem,
      operation: "addcomment",
      user_email: userEmail,
      ticketId: ticketDetails?.id,
      orgId: orgId,
      message : convertHTMLtoMarkdown(comment)
    }
    const response = await retryWrapper({url : GORGIAS_LAMBA_API,httpMethod : "post", params : {orgid : orgId}, payload : requestBody , headers : {"Authorization": `Bearer ${prismToken}`}, dispatch })
    if (response?.status === 200){
      dispatch(toggleSnackbar({
        message: `Added the text to ticket`,
        status: true,
        severity: "success",
      }));
      dispatch(updateEvent("gptInsert",comment.replaceAll('<br>','\n').replaceAll('<p>','\n').replaceAll('</p>','\n'),ticketDetails?.id,ticketDetails?.subject,userEmail,orgId,prismToken))
      dispatch(getTicketDetails(ticketDetails?.id, subDomain, ticketingSystem, orgId, prismToken));
    }else{
    console.error(`request failed with status code ${response?.status}`)
    dispatch(toggleSnackbar({
      message: `Request failed to add comment`,
      status: true,
      severity: "error",
    }));
   }
  }
   catch(error){
    console.error('Error in insertTextToTicket function due to',error)
    dispatch(toggleSnackbar({
      message: `Failed to add comment`,
      status: true,
      severity: "error",
    }));

   }
  }
}

export const getCustomerSummary = (subDomain,ticketingSystem,ticketDetails,userEmail,orgId,prismToken)=>{
  return async (dispatch) =>{
    dispatch({
      type:CUSTOMER_SUMMARY_LOADING,
      payload : true
    })
    try{
      const payload = {
        subdomain: subDomain,
          ticketingSystem: ticketingSystem,
          operation: "customersummary",
          subject: ticketDetails?.subject,
          ticketId: String(ticketDetails?.id),
          description: ticketDetails?.description,
          requester_id: String(ticketDetails?.requester_id),
          orgId: orgId,
          fromApp : true
        }
      const response = await retryWrapper({url : GORGIAS_LAMBA_API,httpMethod : "post", params : {orgid : orgId}, payload , headers : {
                "Authorization": `Bearer ${prismToken}`
              }, dispatch })
      if (response.status === 200){
        dispatch({
          type:SAVE_CUSTOMER_SUMMARY,
          payload : response?.data
        })
        dispatch(updateEvent('customerSummary',"",ticketDetails?.id,ticketDetails?.subject,userEmail,orgId,prismToken))
      }
      else{

        dispatch(toggleSnackbar({
          message: `Customer Summary request failed`,
          status: true,
          severity: "error",
        }));

      }
    }
    catch (error){
      console.error("error in customer summary api",error)
      dispatch(toggleSnackbar({
        message: `Failed to generate customer summary`,
        status: true,
        severity: "error",
      }));
    }
    dispatch({
      type:CUSTOMER_SUMMARY_LOADING,
      payload : false
    })
  }
}

export const getCaseSummary = (subDomain,ticketingSystem,ticketDetails,userEmail,orgId,prismToken)=>{
  return async (dispatch) =>{
    dispatch({
      type:CASE_SUMMARY_LOADING,
      payload : true
    })
    try{
      const payload = {
        subdomain: subDomain,
          ticketingSystem: ticketingSystem,
          operation: "caseSummary",
          subject: ticketDetails?.subject,
          ticketId: String(ticketDetails?.id),
          description: ticketDetails?.description,
          requester_id: String(ticketDetails?.requester_id),
          orgId: orgId,
          fromApp : true
        }
      const response = await retryWrapper({url : GORGIAS_LAMBA_API ,httpMethod : "post" ,params : {orgid : orgId}, payload , headers : {
                "Authorization": `Bearer ${prismToken}`
              }, dispatch})
      if (response.status === 200){
        dispatch({
          type:SAVE_CASE_SUMMARY,
          payload : response?.data
        })
        dispatch(updateEvent('conversationSummary',"",ticketDetails?.id,ticketDetails?.subject,userEmail,orgId,prismToken));
      }else{

        dispatch(toggleSnackbar({
          message: `Case Summary request failed`,
          status: true,
          severity: "error",
        }));

      }
    }
    catch (error){
      console.error("error in customer summary api",error)
      dispatch(toggleSnackbar({
        message: `Failed to generate case summary`,
        status: true,
        severity: "error",
      }));
    }
    dispatch({
      type:CASE_SUMMARY_LOADING,
      payload : false
    })
  }
}


export const getCustomerPastTickets = (subDomain,ticketingSystem,ticketDetails,userEmail,orgId,prismToken)=>{
  return async (dispatch) =>{
    dispatch({
      type:PAST_TICKETS_LOADING,
      payload : true
    })
    try{
      const payload = {
        subdomain: subDomain,
          ticketingSystem: ticketingSystem,
          operation: "getpastickets",
          ticketId: String(ticketDetails?.id),
          requester_id: String(ticketDetails?.requester_id),
          orgId: orgId,
          fromApp : true
        }
      const response = await retryWrapper({url : GORGIAS_LAMBA_API, httpMethod : "post", params : {orgid : orgId}, payload, headers : {
                "Authorization": `Bearer ${prismToken}`
              }, dispatch})
      if (response.status === 200){
        dispatch({
          type:SAVE_PAST_TICKETS,
          payload : response?.data
        })
        dispatch(updateEvent('pastTickets',"",ticketDetails?.id,ticketDetails?.subject,userEmail,orgId,prismToken));
      }else{

        dispatch(toggleSnackbar({
          message: `Past Tickets request failed`,
          status: true,
          severity: "error",
        }));

      }
    }
    catch (error){
      console.error("error in customer summary api",error)
      dispatch(toggleSnackbar({
        message: `Failed to fetch the past tickets`,
        status: true,
        severity: "error",
      }));
    }
    dispatch({
      type:PAST_TICKETS_LOADING,
      payload : false
    })
  }
}


export const updateEvent = (type,resource,ticketId,queryText,userEmail,orgId,prismToken)=>{
  return async (dispatch) =>{
    try{
      const payload = {
        "event": {
            "type": type === 'like' || type === 'dislike' ? resource+type : type,
            "ticket_id": ticketId,
            "_queryText": queryText || "" ,
            "source": resource,
            "orgId": orgId,
            "agent": userEmail
        }
    }
      const response = await retryWrapper({url : EVENTS,httpMethod : "post", params : {orgid : orgId}, payload , headers : {
                "Authorization": `Bearer ${prismToken}`
              }, dispatch })
      if (response.status !== 200){
        dispatch(toggleSnackbar({
          message: `Update event request failed`,
          status: true,
          severity: "error",
        }));

      }
    }
    catch (error){
      console.error("error in update events api",error)
      dispatch(toggleSnackbar({
        message: `Failed to update the events`,
        status: true,
        severity: "error",
      }));
    }
  }
}

